// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__243iv","errors":"Errors_errors__6-upk"};